import { useParams } from "react-router-dom";
import cars from "../data/cars";
import { Link } from "react-router-dom";


function CarDetails() {

  const { id } =
    useParams();

  const car =
    cars.find(
      (c) =>
        c.id === Number(id)
    );

  return (
    <section className="car-details">

      <img
        src={car.image}
        alt={car.name}
      />

      <div className="details">

        <h1>
          {car.name}
        </h1>

        <h2>
          {car.price}
        </h2>

        <p>
          Premium luxury vehicle with
          outstanding performance and
          cutting-edge technology.
        </p>

  <Link to="/booking">

  <button className="btn">

    Book Test Drive

  </button>

</Link>

      </div>

    </section>
  );
}

export default CarDetails;